export const TickIcon = ({ className, ...props }: JSX.HTMLAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <path
      d="M1.49854 8.74992L5.2483 12.4999L12.7478 1.25"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
